var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{attrs:{"commit":_vm.doCommit,"theValue":_vm.theValue}},[_c('input',{staticClass:"form-control",attrs:{"type":"text","size":_vm.size},domProps:{"value":_vm.theValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }